import { Component } from "react";
import Popup from "..";
import RectButton from "../../ui/button/RectButton";
import Input from "../../ui/Input";
import Select from "../../ui/Select";
import Option from "../../ui/Select/Option";

class EditAddressPopup extends Component {
    render() {
        return (
            <Popup className="edit-address-popup">
                <h3>{this.props.edit ? "Edit Address" : "New Address"}</h3>
                <div className="column">
                    <div className="row">
                        <Input placeHolder="First Name" />
                        <Input placeHolder="Last Name" />
                    </div>
                    <Input placeHolder="Griflan Design, Inc." />
                    <Input placeHolder="4206 Spruce Street" />
                    <Input placeHolder="Address 2 (Optional)" />
                    <div className="row">
                        <Input placeHolder="Philadelphia" />
                        <Select style={{flex:.5}}>
                            <Option value="1">PA</Option>
                        </Select>
                        <Input placeHolder="19104" />
                    </div>
                    <Select>
                        <Option value="1">United States</Option>
                    </Select>
                    <RectButton text="UPDATE ADDRESS" />
                </div>
            </Popup>
        )
    }
}

export default EditAddressPopup;